import get from 'lodash.get';

const getWonderChatId = (rootState) => get(rootState, 'config.common.wonderchat.id');

export default getWonderChatId;
